import { Injectable } from '@angular/core'
import { EventLoggingParams, LogEvent, LogEventKey } from 'src/app/interfaces/log'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class HspQuizLogService {
  constructor(private logService: LogService) { }

  // [HSP퀴즈 - 랜딩] 화면 진입
  logHspQuizLandingPageViewed(): void {
    this.eventLogging(LogEvent.HSP_QUIZ_LANDING_PAGE_VIEWED)
  }
  // [HSP퀴즈 - 랜딩] 시작 버튼 클릭
  logHspQuizLandingStartButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_QUIZ_LANDING_START_BUTTON_CLICKED)
  }
  // [HSP퀴즈 - 랜딩] - HSP 궁금하다면 버튼 클릭
  logHspQuizLandingAboutHspButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_QUIZ_LANDING_ABOUT_HSP_BUTTON_CLICKED)
  }
  // [HSP퀴즈 - 생성] 화면 진입
  logHspQuizCreationPageViewed(step: number): void {
    this.eventLogging(LogEvent.HSP_QUIZ_CREATION_PAGE_VIEWED, { step })
  }
  // [HSP퀴즈 - 생성] 다음 버튼 클릭
  logHspQuizCreationNextButtonClicked(step: number): void {
    this.eventLogging(LogEvent.HSP_QUIZ_CREATION_NEXT_BUTTON_CLICKED, { step })
  }
  // [HSP퀴즈 - 응답] 화면 진입
  logHspQuizReplyPageViewed(step: number): void {
    this.eventLogging(LogEvent.HSP_QUIZ_REPLY_PAGE_VIEWED, { step })
  }
  // [HSP퀴즈 - 응답] 다음 버튼 클릭
  logHspQuizReplyNextButtonClicked(step: number): void {
    this.eventLogging(LogEvent.HSP_QUIZ_REPLY_NEXT_BUTTON_CLICKED, { step })
  }
  // [HSP호스트퀴즈리포트] - 화면 진입
  logHspHostQuizReportPageViewed(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_PAGE_VIEWED)
  }
  // (Web Only) [HSP호스트퀴즈리포트] - 저장하기 클릭
  logHspHostQuizReportSaveButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_SAVE_BUTTON_CLICKED)
  }
  // (Web Only) [HSP호스트퀴즈리포트] - 타입스 앱으로 이용하기 클릭
  logHspHostQuizReportUseAppButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_USE_APP_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 내 테스트 결과 탭 클릭
  logHspHostQuizReportMyTestResultTabClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_MY_TEST_RESULT_TAB_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 친구들이 보는 나 탭 클릭
  logHspHostQuizReportReplyListTabClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_REPLY_LIST_TAB_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 민감성 유형별 요약 설명 클릭
  logHspHostQuizReportSummaryDescriptionByTypeOfSensitivityClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_SUMMARY_DESCRIPTION_BY_TYPE_OF_SENSITIVITY_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 남들이 보는 나는 어떤지 확인하고 싶다면 클릭
  logHspHostQuizReportNavigateToReplyListButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_NAVIGATE_TO_REPLY_LIST_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 내 MBTI 확인하기 클릭
  logHspHostQuizReportCheckMyMbtiButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_CHECK_MY_MBTI_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 테스트 공유 버튼 클릭 (하단 linear 공유)
  logHspHostQuizReportShareTestButtonClicked(type: 'kakao' | 'x' | 'qr' | 'link'): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_SHARE_TEST_BUTTON_CLICKED, { type })
  }
  // [HSP호스트퀴즈리포트] - 민감한 특징 상세 클릭 (내가 가진 민감한 특징, 다른 민감한 특징들)
  logHspHostQuizReportDetailedSensitiveFeaturesClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_DETAILED_SENSITIVE_FEATURES_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 민감도 등급 클릭 (초초민감자, 초민감자, …)
  logHspHostQuizReportSensitivityRatingClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_SENSITIVITY_RATING_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 퀴즈 공유하기 클릭 (상단 공유)
  logHspHostQuizReportShareQuizButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_SHARE_QUIZ_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 링크 복사 클릭 (상단 공유)
  logHspHostQuizReportCopyLinkButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_COPY_LINK_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] -  QR 공유 클릭 (상단 공유)
  logHspHostQuizReportQrCodeButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_QR_CODE_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 응답 클릭
  logHspHostQuizReportReplyClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_REPLY_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 자세히 탐구하기 클릭
  logHspHostQuizReportInvestigateDeeplyClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_INVESTIGATE_DEEPLY_CLICKED)
  }
  // [HSP게스트퀴즈리포트] - 화면 진입
  logHspGuestQuizReportPageViewed(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.HSP_GUEST_QUIZ_REPORT_PAGE_VIEWED, { viewerType })
  }
  // [HSP게스트퀴즈리포트] - 민감도 등급 클릭 (초초민감자, 초민감자, …)
  logHspGuestQuizReportSensitivityRatingClicked(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.HSP_GUEST_QUIZ_REPORT_SENSITIVITY_RATING_CLICKED, { viewerType })
  }
  // [HSP게스트퀴즈리포트] - HSP 설명 자세히 보기 클릭
  logHspGuestQuizReportViewDetailedDescriptionClicked(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.HSP_GUEST_QUIZ_REPORT_VIEW_DETAILED_DESCRIPTION_CLICKED, { viewerType })
  }
  // [HSP게스트퀴즈리포트] - 모든응답 page 버튼 클릭
  logHspGuestQuizReportAllReplyPageButtonClicked(viewerType: 'host' | 'guest', buttonType: 'next' | 'prev'): void {
    this.eventLogging(LogEvent.HSP_GUEST_QUIZ_REPORT_ALL_REPLY_PAGE_BUTTON_CLICKED, { viewerType, buttonType })
  }
  // [HSP게스트퀴즈리포트] - 민감성 유형별 설명 클릭
  logHspGuestQuizReportDescriptionByTypeOfSensitivityClicked(viewerType: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.HSP_GUEST_QUIZ_REPORT_DESCRIPTION_BY_TYPE_OF_SENSITIVITY_CLICKED, { viewerType })
  }
  // [HSP게스트퀴즈리포트] - 내 민감도 레벨 확인하기 버튼 클릭
  logHspGuestQuizReportCheckMySensitivityLevelButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_GUEST_QUIZ_REPORT_CHECK_MY_SENSITIVITY_LEVEL_BUTTON_CLICKED)
  }
  // [HSP설명] - 화면 진입
  logHspDescriptionPageViewed(): void {
    this.eventLogging(LogEvent.HSP_DESCRIPTION_PAGE_VIEWED)
  }
  // [HSP 민감한 특징들 설명] - 화면 진입
  logHspDescriptionSensitiveFeaturesPageViewed(): void {
    this.eventLogging(LogEvent.HSP_DESCRIPTION_SENSITIVE_FEATURES_PAGE_VIEWED)
  }
  // [HSP 민감한 특징들 설명] - 강점/약점 펼쳐보기 클릭
  logHspDescriptionSensitiveFeaturesStrengthsAndWeaknessesExpandClicked(): void {
    this.eventLogging(LogEvent.HSP_DESCRIPTION_SENSITIVE_FEATURES_STRENGTHS_AND_WEAKNESSES_EXPAND_CLICKED)
  }
  // [HSP 민감한 특징들 설명] - 친구에게도 이 테스트 알려주기 클릭
  logHspDescriptionSensitiveFeaturesShareTestButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_DESCRIPTION_SENSITIVE_FEATURES_SHARE_TEST_BUTTON_CLICKED)
  }
  // [HSP 민감한 특징들 설명] - 더 구체적인 내용 탐색해보기 클릭
  logHspDescriptionSensitiveFeaturesInvestigateDeeplyClicked(): void {
    this.eventLogging(LogEvent.HSP_DESCRIPTION_SENSITIVE_FEATURES_INVESTIGATE_DEEPLY_CLICKED)
  }

  // [HSP 이미 푼 퀴즈 선택] - 화면 진입
  logHspQuizSelectPageViewed(): void {
    this.eventLogging(LogEvent.HSP_QUIZ_SELECT_PAGE_VIEWED)
  }
  // [HSP 이미 푼 퀴즈 선택] - 새로 만들기 클릭
  logHspQuizSelectCreateButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_QUIZ_SELECT_CREATE_BUTTON_CLICKED)
  }
  // [HSP 이미 푼 퀴즈 선택] - 앱 설치 클릭
  logHspQuizSelectInstallAppButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_QUIZ_SELECT_INSTALL_APP_BUTTON_CLICKED)
  }
  // [HSP 이미 푼 퀴즈 선택] - 결과 아이템 클릭
  logHspQuizSelectResultItemClicked(): void {
    this.eventLogging(LogEvent.HSP_QUIZ_SELECT_RESULT_ITEM_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 앱에서 보기 floating 버튼 클릭
  logHspHostQuizReportViewInAppFloatingButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_VIEW_IN_APP_FLOATING_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 노출
  logHspHostQuizReportLoginOrInstallAppModalViewed(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_VIEWED)
  }
  // [HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 로그인 클릭
  logHspHostQuizReportLoginOrInstallAppModalLoginButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_LOGIN_BUTTON_CLICKED)
  }
  // [HSP호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 앱 설치 클릭
  logHspHostQuizReportLoginOrInstallAppModalInstallButtonClicked(): void {
    this.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_LOGIN_OR_INSTALL_APP_MODAL_INSTALL_BUTTON_CLICKED)
  }
  //[Hsp호스트퀴즈리포트]- MBTI 통계 노출
  logHspHostQuizReportMbtiStatisticsViewed() {
    this.logService.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_MBTI_STATISTICS_VIEWED);
  }
  //[Hsp호스트퀴즈리포트]- MBTI 변경하기 버튼 클릭
  logHspHostQuizReportMbtiSelectButtonClicked() {
    this.logService.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_MBTI_SELECT_BUTTON_CLICKED);
  }
  //[Hsp Mbti 선택]- 화면 진입
  logHspMbtiSelectPageViewed() {
    this.logService.eventLogging(LogEvent.HSP_MBTI_SELECT_PAGE_VIEWED);
  }
  //[Hsp Mbti 선택]- Mbti 아이템 클릭
  logHspMbtiSelectMbtiItemClicked() {
    this.logService.eventLogging(LogEvent.HSP_MBTI_SELECT_MBTI_ITEM_CLICKED);
  }
  //[Hsp Mbti 선택]- Mbti 상세 결과 버튼 클릭
  logHspMbtiSelectMbtiReportButtonClicked() {
    this.logService.eventLogging(LogEvent.HSP_MBTI_SELECT_MBTI_REPORT_BUTTON_CLICKED);
  }
  //[Hsp Mbti 선택] - 새로 만들기 클릭
  logHspMbtiSelectCreateNewButtonClicked() {
    this.logService.eventLogging(LogEvent.HSP_MBTI_SELECT_CREATE_NEW_BUTTON_CLICKED);
  }
  //[Hsp호스트 퀴즈 리포트] - 타입스 스토리 배너 노출
  logHspHostQuizReportTypesStoryBannerViewed() {
    this.logService.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_VIEWED);
  }
  //[Hsp호스트 퀴즈 리포트] - 타입스 스토리 배너 편지 버튼 클릭
  logHspHostQuizReportTypesStoryBannerLetterButtonClicked() {
    this.logService.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_LETTER_BUTTON_CLICKED);
  }
  //[Hsp호스트 퀴즈 리포트] - 타입스 스토리 배너 노트 버튼 클릭
  logHspHostQuizReportTypesStoryBannerNoteButtonClicked() {
    this.logService.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_NOTE_BUTTON_CLICKED);
  }
  //[Hsp호스트퀴즈리포트] - 로그인/앱설치 선택 모달 - 앱 설치 클릭
  logHspHostQuizReportTypesStoryBannerInstallButtonClicked() {
    this.logService.eventLogging(LogEvent.HSP_HOST_QUIZ_REPORT_TYPES_STORY_BANNER_INSTALL_BUTTON_CLICKED);
  }
  //[타입스 스토리] - 화면 진입
  logTypesStoryPageViewed() {
    this.logService.eventLogging(LogEvent.TYPES_STORY_PAGE_VIEWED);
  }
  //[타입스 스토리] - 개발자 노트 버튼 클릭
  logTypesStoryDevelopersNoteButtonClicked() {
    this.logService.eventLogging(LogEvent.TYPES_STORY_DEVELOPERS_NOTE_BUTTON_CLICKED);
  }
  //[타입스 스토리] - 앱 버튼 클릭
  logTypesStoryAppButtonClicked() {
    this.logService.eventLogging(LogEvent.TYPES_STORY_APP_BUTTON_CLICKED);
  }
  //[타입스 스토리] - 공유 버튼 클릭
  logTypesStoryShareButtonClicked(type: 'kakao' | 'qr' | 'x' | 'link') {
    this.logService.eventLogging(LogEvent.TYPES_STORY_SHARE_BUTTON_CLICKED, { type });
  }

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      ...params,
    })
  }
}
